<template>
  <!-- DETAIL ZARIZENI -->
  <div class="detail-page">
    <div v-if="device" :class="{ visible: isHeaderFixed }" class="detail-page__sticky-header d-flex align-items-center">
      <div class="detail-page__sticky-header__left d-flex align-items-center">
        <strong class="detail-page__sticky-header__name">
          {{ $filters.strLimit(device.custDeviceName, 8) }}
        </strong>
        <DeviceStatusIcon :device="device" />
        {{ $t("pred") }}
        {{ $filters.beforeTime(device.lastMessageIn, "short") }}
      </div>
      <div class="detail-page__sticky-header__right d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <div :class="{ active: selectedTab === 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
            {{ $t("routovaciSkupiny") }}
          </div>
          <div :class="{ active: selectedTab === 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
            {{ $t("zpravy") }}
          </div>
          <div :class="{ active: selectedTab === 3 }" class="detail-page__tabs__tab" @click="selectedTab = 3">
            {{ $t("vseOZarizeni") }}
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end detail-page__sticky-header__buttons">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditDeviceModal('editDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleMoveDeviceModal('moveDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/icon_move.svg" />
            </div>
            {{ $t("MOVE_DEVICE_DETAIL") }}
          </button>
          <button
            v-if="device.partnerId === 3"
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleSendMessageModal('sendMessage')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-send.svg" />
            </div>
            {{ $t("poslatZpravu") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteDevice([device])"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div v-if="device" id="detail-header" class="layout__content__header layout__content__header--white">
      <Back :route="'/devices/lora/' + customerId + '/' + projectId" :text="'naSeznamZarizeni'" />
      <div class="d-flex justify-content-between">
        <h1 class="mb-0 layout__content__header__title">
          {{ device.custDeviceName }}
        </h1>
        <div class="layout__content__header__buttons d-none d-md-flex justify-content-end align-items-end">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditDeviceModal('editDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleMoveDeviceModal('moveDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/icon_move.svg" />
            </div>
            {{ $t("MOVE_DEVICE_DETAIL") }}
          </button>
          <button
            v-if="device.partnerId === 3"
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleSendMessageModal('sendMessage')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-send.svg" />
            </div>
            {{ $t("poslatZpravu") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteDevice([device])"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>

        <div
          :class="{ opened: openedDropdown }"
          class="layout__content__header__buttons--mobile d-md-none align-self-end"
          @click="toggleDropdown()"
        >
          <div class="btn btn-primary d-flex align-items-center justify-content-center">
            <img class="mr-2 dropdown-actions__icon" src="@/assets/icons/actions/ico-ico-btn-akce.svg" />
            {{ $filters.firstUpper($t("akce")) }}
            <div class="dropdown-actions__wrapper">
              <div class="dropdown-actions__inner">
                <div
                  class="dropdown-actions__item d-flex align-items-center"
                  @click="toggleEditDeviceModal('editDevice')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                  </div>
                  {{ $filters.firstUpper($t("upravit")) }}
                </div>
                <div
                  v-if="device.partnerId === 3"
                  class="dropdown-actions__item d-flex align-items-center"
                  @click="toggleSendMessageModal('sendMessage')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
                  </div>
                  {{ $filters.firstUpper($t("poslatZpravu")) }}
                </div>
                <div class="dropdown-actions__item d-flex align-items-center" @click="toggleDeleteDevice([device])">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete.svg" />
                  </div>
                  {{ $filters.firstUpper($t("odstranitZarizeni")) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeviceStatusIcon :device="device" class="mb-3 mb-md-5" show-description />
      <div class="detail-page__info d-flex align-items-center font-weight-light">
        <span v-if="device" class="detail-page__info__item">
          {{ device.deviceId }}
        </span>
        <span class="detail-page__info__item">LoRa</span>
        <span v-if="device.parameters" class="detail-page__info__item">
          {{ device.parameters.devicetype }}
        </span>
        <!--span class="detail-page__info__item gray-text-light">Je to na chodbě ve skříni</span-->
      </div>
      <div v-if="device" class="detail-page__boxes d-flex flex-column flex-md-row">
        <!-- SIGNAL RSSI STATUS -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("RSSI") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <RssiIcon :last-message-in="lastMessageIn" />
          </div>
        </div>
        <!-- SIGNAL STRENGTH STATUS -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("SNR") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <SnrIcon :last-message-in="lastMessageIn" />
          </div>
        </div>

        <!-- SIGNAL RSSI STATUS -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("Poslední zpráva") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <span
              v-if="device.lastMessageIn != null"
              class="link-gray font-weight-bolder"
              @click="showMessage(lastMessageIn)"
            >
              <span>
                {{ $t("pred") }}
                {{ $filters.beforeTime(device.lastMessageIn, "short") }}
              </span>
            </span>
            <span v-else>N/A</span>
          </div>
        </div>

        <!-- BATTERY STATUS -->
        <div class="detail-page__boxes__item battery">
          <p class="label font-weight-light">
            {{ $t("stavBaterie") }}
          </p>
          <div class="detail-page__boxes__value">
            <BatteryStatusIcon :device="device" />
          </div>
        </div>
        <!-- SERVICE BOX -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $filters.firstUpper($t("sluzba")) }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="atom-icon justify-content-start">
              <img src="@/assets/icons/sluzba-check.svg" />
            </div>
            <span v-if="service" class="detail-page__boxes__item__textDashed">
              {{ service.custServiceName }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="device" class="detail-page__tags d-flex flex-column flex-sm-row font-weight-light align-items-start">
        <div v-if="visibleTags.length" class="d-flex flex-column flex-md-row detail-page__tags__tagRow">
          {{ $filters.firstUpper($t("tagy")) }}
          <div class="ml-md-2 mr-md-4 d-flex align-items-center flex-wrap">
            <TagBubbles :tag-list="device.tags" />
          </div>
        </div>
        <div
          v-if="Object.keys(visibleAttributes).length"
          class="d-flex flex-column flex-md-row mt-3 mt-sm-0 detail-page__tags__paramsRow"
        >
          {{ $filters.firstUpper($t("parametry")) }}
          <UserAttributesBubbles :attributes="device.attributes" />
        </div>
      </div>

      <div v-if="selectedTab == 2">
        <RadioHelp
          :article-link="'/zarizeni/zpravy'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab == 1">
        <RadioHelp
          :article-link="'/zarizeni/skupiny'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab == 3">
        <RadioHelp
          :article-link="'/zarizeni/informace'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
    </div>

    <div class="layout__content__content pt-0 px-0">
      <div id="tabs" class="detail-page__tabs">
        <div class="detail-page__tabs__header d-flex">
          <div class="d-flex align-items-end detail-page__tabs__wrapper">
            <div :class="{ active: selectedTab == 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
              {{ $filters.firstUpper($t("routovaciSkupiny")) }}
            </div>
            <div
              :class="{ active: selectedTab == 2 }"
              class="detail-page__tabs__tab position-relative"
              @click="selectedTab = 2"
            >
              {{ $filters.firstUpper($t("zpravy")) }}
              <div v-if="suspendedMessagesCount" class="notification-icon">
                {{ suspendedMessagesCount }}
              </div>
            </div>
            <div
              :class="{ active: selectedTab == 3 }"
              class="detail-page__tabs__tab position-relative"
              @click="selectedTab = 3"
            >
              {{ $filters.firstUpper($t("vseOZarizeni")) }}
              <div v-if="deviceInfoProblemCount" class="notification-icon">
                {{ deviceInfoProblemCount }}
              </div>
            </div>

            <RadioOpenClose
              :radio-slides="radioSlides"
              :show="showHelp"
              @update-show-radio-help="showRadioHelp($event)"
            />
          </div>
        </div>
        <div class="detail-page__tabs__content overflow-visible">
          <div v-show="selectedTab === 1">
            <DataFlowOverview
              v-if="device"
              :device="device"
              :groups="groups"
              :groups-endpoints="groupsEndpoints"
              :last-message-in="lastMessageIn"
              :transform-key="transformKey"
              device-type="lora"
              @edit-device="toggleEditDeviceModal('editDevice')"
              @reload-device="loadDevice"
              @reload-groups="loadGroupEndpoints"
              @show-message="showMessage"
            />
          </div>
          <div v-if="selectedTab === 2" class="messages">
            <DeviceMessages
              :device="device"
              :device-id="device.deviceId"
              :reload-d-m="reloadDM"
              @set-reload-d-m="setReloadDM"
              @show-message="showMessage"
              @toggle-send-message-modal="toggleSendMessageModal"
            />
          </div>
          <div v-if="selectedTab === 3">
            <div class="about">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div v-if="device" class="about__section">
                    <div class="about__title">
                      <strong>
                        {{ $filters.firstUpper($t("informaceOZarizeni")) }}
                      </strong>
                    </div>
                    <div class="about__info">
                      <div class="about__info__row d-flex align-items-start">
                        <div class="about__info__label gray-text-light">
                          {{ $filters.firstUpper($t("nazevZarizeni")) }}
                        </div>
                        <div class="about__info__value">
                          {{ device.custDeviceName }}
                        </div>
                      </div>
                      <div class="about__info__row d-flex align-items-start">
                        <div class="about__info__label gray-text-light">
                          {{ $filters.firstUpper($t("Rezim")) }}
                        </div>
                        <div class="about__info__value">
                          <DeviceStatusIcon :device="device" show-description />
                        </div>
                      </div>
                      <!--div class="about__info__row d-flex align-items-start">
                      <div class="about__info__label gray-text-light">
                        {{ $t("popis") }}
                      </div>
                      <div class="about__info__value">
                        Je to ve skříni na mezipatře.
                      </div>
                    </div-->

                      <div
                        v-if="device.status === 'preregistration' && device.preregistrationEnd != null"
                        class="about__info__row d-flex align-items-start"
                      >
                        <div class="about__info__label gray-text-light">{{ $t("PREDREGISTRACE_DO") }}:</div>
                        <div class="about__info__value">
                          <span v-html="$filters.dateTime(device.preregistrationEnd)" />
                        </div>
                      </div>
                      <div
                        v-if="device.status === 'preregistration' && device.preregistrationMsgsLeft > 0"
                        class="about__info__row d-flex align-items-start"
                      >
                        <div v-if="device.preregistrationMsgsLeft == 1">
                          <div class="about__info__label gray-text-light">{{ $t("DO_AKTIVACE_ZBYVA") }}:</div>
                          <div class="about__info__value">1 {{ $t("ZPRAVA") }}</div>
                        </div>
                        <div
                          v-else-if="device.preregistrationMsgsLeft > 1 && device.preregistrationMsgsLeft < 5"
                          class="about__info__row d-flex align-items-start"
                        >
                          <div class="about__info__label gray-text-light">{{ $t("DO_AKTIVACE_ZBYVAJI") }}:</div>
                          <div class="about__info__value">
                            {{ device.preregistrationMsgsLeft }}
                            {{ $t("zpravy") }}
                          </div>
                        </div>
                        <div
                          v-else-if="device.preregistrationMsgsLeft > 4"
                          class="about__info__row d-flex align-items-start"
                        >
                          <div class="about__info__label gray-text-light">{{ $t("DO_AKTIVACE_ZBYVA") }}:</div>
                          <div class="about__info__value">
                            {{ device.preregistrationMsgsLeft }}
                            {{ $t("zprav") }}
                          </div>
                        </div>
                      </div>

                      <div v-if="visibleTags.length" class="about__info__row d-flex align-items-start">
                        <div class="about__info__label gray-text-light">
                          {{ $filters.firstUpper($t("tagy")) }}
                        </div>
                        <div class="about__info__value">
                          <TagBubbles :tag-list="device.tags" />
                        </div>
                      </div>
                      <div class="about__info__row d-flex align-items-start">
                        <div class="about__info__label gray-text-light">
                          {{ $filters.firstUpper($t("Typ zařízení")) }}
                        </div>
                        <div class="about__info__value">LoRa</div>
                      </div>
                      <div class="about__info">
                        <div class="about__info__row d-flex align-items-start">
                          <div class="about__info__label gray-text-light">
                            {{ $filters.firstUpper($t("zpusobAktivace")) }}
                          </div>
                          <div class="about__info__value">
                            {{ device.parameters.devicetype }}
                          </div>
                        </div>
                        <div class="about__info__row d-flex align-items-start">
                          <div class="about__info__label gray-text-light">
                            {{ $filters.firstUpper($t("identifikatorZarizeni")) }}
                          </div>
                          <div class="about__info__value">
                            {{ device.deviceId }}
                          </div>
                        </div>
                        <div class="about__info__row d-flex align-items-start">
                          <div class="about__info__label gray-text-light">
                            {{ $filters.firstUpper($t("jakZarizeniNasloucha")) }}
                          </div>
                          <div class="about__info__value">
                            <span v-if="device.parameters.devclass == 'A'">
                              {{ device.parameters.devclass }} -
                              {{ $t("pouzePriOdesilani") }}
                            </span>
                            <span v-else>
                              {{ device.parameters.devclass }} -
                              {{ $t("devclassC") }}
                            </span>
                          </div>
                        </div>
                        <div v-if="transformationFunction" class="about__info__row d-flex align-items-start">
                          <div class="about__info__label gray-text-light">
                            {{ $filters.firstUpper($t("TRANSFORMATION_FUNCTION")) }}
                          </div>
                          <div class="about__info__value">
                            {{ transformationFunction.label }}
                          </div>
                        </div>
                        <div v-if="hwDevice" class="about__info__row d-flex align-items-start">
                          <div class="about__info__label gray-text-light">
                            {{ $filters.firstUpper($t("HW_DEVICE")) }}
                          </div>
                          <div class="about__info__value">
                            {{ hwDevice.manufacturer }} / {{ hwDevice.model }} / {{ hwDevice.revision }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="Object.keys(visibleAttributes).length" class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("USER_ATTRIBUTES")) }}
                  </strong>
                </div>
                <div v-for="(value, name) in visibleAttributes" :key="name">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ name }}
                    </div>
                    <div class="about__info__value">
                      {{ value }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("zpravyZarizeni")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("posledniZpravaZeZarizeni")) }}
                    </div>
                    <div
                      v-if="device.lastMessageIn"
                      class="about__info__value link"
                      @click="showMessage(lastMessageIn)"
                    >
                      {{ $t("pred") }}
                      {{ $filters.beforeTime(device.lastMessageIn, "short") }}
                    </div>
                    <div v-else class="about__info__value">
                      {{ $t("neni") }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("pocetGateways")) }}
                    </div>
                    <div v-if="lastMessageIn && lastMessageIn.message" class="about__info__value">
                      {{ lastMessageIn.message.gws?.length }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("silaSignalu")) }}
                    </div>
                    <div class="about__info__value">
                      <SignalStrengthIcon :device="device" />
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">RSSI</div>
                    <div class="about__info__value">
                      <span v-if="lastMessageIn">{{ lastMessageIn.rssi }} dBm</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">SNR</div>
                    <div class="about__info__value">
                      <span v-if="lastMessageIn">{{ lastMessageIn.snr }} dB</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("stavBaterie")) }}
                    </div>
                    <div class="about__info__value">
                      <span
                        v-if="device.bateryStatus > 0 && device.bateryStatus < 255"
                        class="d-flex align-items-center"
                      >
                        {{ Math.round((device.bateryStatus / 254) * 100, 2) }}
                        %
                      </span>
                      <span v-if="device.bateryStatus == 0">AC</span>
                      <span v-if="device.bateryStatus == 255 || device.bateryStatus == null">N/A</span>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PosledniZpravaDoZarizeni")) }}
                    </div>
                    <div class="about__info__value">
                      <a v-if="device.lastMessageOut" class="link-message" @click="showMessage(lastMessageOut)">
                        <span v-html="$filters.dateTime(device.lastMessageOut)" />
                      </a>
                      <div v-else>
                        {{ $t("neni") }}
                      </div>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light" />
                    <div class="about__info__value">
                      <span v-if="device.partnerId === 3" class="link" @click="toggleSendMessageModal('sendMessage')">
                        {{ $filters.firstUpper($t("poslatZpravu")) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("sluzbaALimity")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("sluzba")) }}
                    </div>
                    <div v-if="service" class="about__info__value d-flex align-items-center">
                      <div>
                        {{ service.custServiceName }}
                        <br />
                        <small>{{ service.custServiceId }}</small>
                      </div>
                      <div
                        v-if="service.suspended"
                        v-tooltip
                        :title="$t('SERVICE_SUSPENDED')"
                        class="ml-4 d-flex align-items-center"
                      >
                        <span class="atom-circle atom-circle--danger">!</span>
                        <span class="ml-1 text-white bg-danger p-1 border-radius">
                          {{ $t("SUSPENDED") }}
                        </span>
                      </div>
                      <div
                        v-if="service.discontinued"
                        v-tooltip
                        :title="$t('SERVICE_DISCONTINUED')"
                        class="ml-4 d-flex align-items-center"
                      >
                        <span class="atom-circle atom-circle--danger">!</span>
                        <span class="ml-1 text-white bg-danger p-1 border-radius">
                          {{ $t("DISCONTINUED") }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("limitOdchozichZprav")) }}
                    </div>
                    <div class="about__info__value">
                      {{ device.limits.messageOutDaily }}/{{ $t("den") }} -
                      {{ $t("vycerpano") }}
                      {{ device.counters.messageOutDaily }} ({{
                        Math.round(device.counters.messageOutDaily / (device.limits.messageOutDaily / 100))
                      }}
                      %)
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("limitPrichozichZprav")) }}
                    </div>
                    <div v-if="service" class="about__info__value">
                      {{ device.limits.messageInDaily }}/{{ $t("den") }} -
                      {{ $t("vycerpano") }}
                      {{ device.counters.messageInDaily }} ({{
                        Math.round(device.counters.messageInDaily / (device.limits.messageInDaily / 100))
                      }}
                      %)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="device">
      <ShowMessage
        :device="device"
        :item="selectedMessage"
        :opened="openedMessageDetail"
        @close-box="toggleShowMessage"
      />
      <DeleteDeviceModal
        :centered="true"
        :items="[device]"
        :opened="openedDeleteDevice"
        :text="deleteText"
        @close="toggleDeleteDevice()"
        @yes="
          () => {
            deleteDevice()
            toggleDeleteDevice()
          }
        "
      />
      <SendMessageModal
        :devices="[device]"
        :opened="openedSendMessage"
        @close-box="toggleSendMessageModal"
        @open-box="toggleSendMessageModal"
        @reload-messages="setReloadDM"
      />
      <EditDeviceModal
        v-if="openedEditDevice.length > 0"
        :device="device"
        :opened="openedEditDevice"
        :tags="device.tags"
        @close-box="toggleEditDeviceModal"
        @open-box="toggleEditDeviceModal"
        @transform-updated="handleTransformUpdated"
        @update-items="loadDevice"
      />
      <MoveDeviceModal
        v-if="openedMoveDevice.length > 0"
        :devices="[device]"
        :opened="openedMoveDevice"
        @close-box="toggleMoveDeviceModal"
        @device-moved="handleDeviceMoved"
        @open-box="toggleMoveDeviceModal"
      />
      <div v-if="errorsToTranslate.length > 0">
        <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import Back from "@/components/back.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import DataFlowOverview from "@/components/devices/partials/DataFlowOverview.vue"
import DeviceMessages from "@/components/devices/messages.vue"
import ShowMessage from "@/components/modals/devices/messageShow.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import SendMessageModal from "@/components/modals/devices/sendMessage.vue"
import EditDeviceModal from "@/components/modals/devices/edit.vue"
import MoveDeviceModal from "@/components/modals/devices/move.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import BatteryStatusIcon from "@/components/boxes/batteryStatusIcon.vue"
import SignalStrengthIcon from "@/components/boxes/signalStrengthIcon.vue"
import RssiIcon from "@/components/boxes/rssiIcon.vue"
import SnrIcon from "@/components/boxes/snrIcon.vue"
import { mapMutations, mapState } from "vuex"
import router from "@/router"
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue"
import TagBubbles from "@/components/devices/tagBubbles.vue"
import UserAttributesBubbles from "@/components/devices/userAttributesBubbles.vue"
import { getVisibleAttributes, getVisibleTags } from "@/plugins/getVisible"
import { client } from "@/main"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"
import { useProjectStore } from "@/store/modules/project"
import { useLoraStore } from "@/store/modules/devices/lora"

export default {
  components: {
    DeviceStatusIcon,
    DataFlowOverview,
    SignalStrengthIcon,
    BatteryStatusIcon,
    RssiIcon,
    SnrIcon,
    Back,
    RadioHelp,
    RadioOpenClose,
    DeviceMessages,
    ShowMessage,
    DeleteDeviceModal,
    SendMessageModal,
    EditDeviceModal,
    MoveDeviceModal,
    ErrorModal,
    TagBubbles,
    UserAttributesBubbles
  },
  props: {
    // FIXME tyhle props jsou podle mě k prdu
    projectId: String,
    customerId: String
  },
  setup() {
    const authStore = useAuthStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const loraStore = useLoraStore()

    return {
      authStore,
      projectStore,
      configStore,
      loraStore
    }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: !this.configStore.isRadioHelpDisabled,
      selectedProjectId: this.$router.currentRoute.value.params.projectId,
      selectedCustomerId: this.$router.currentRoute.value.params.customerId,
      deviceId: this.$route.params.id,
      device: this.$route.params.device,
      newAttributes: {},
      newTags: [],
      props: {
        device: Object
      },
      groups: [],
      groupsEndpoints: [],
      signal: 2,
      selectedTab: 1,
      service: {},
      openedGroups: [],
      openedDropdown: false,
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      sort: "%2Dcode",
      messages: [],
      openedMessageDetail: [],
      selectedMessage: {},
      lastMessageIn: {},
      lastMessageOut: {},
      openedDeleteDevice: false,
      deleteText: "",
      openedSendMessage: [],
      openedEditDevice: [],
      openedMoveDevice: [],
      reloadDM: false,
      errorsToTranslate: [],
      openedError: false,
      allLogs: [],
      allMessages: [],
      articleLink: "",
      isActionsDropdownVisible: false,
      transformKey: Math.random().toString(),
      suspendedMessagesCount: false,
      hwDevice: null,
      transformationFunction: null
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    locale() {
      return this.$i18n.locale
    },
    deviceInfoProblemCount() {
      let count = 0
      if (this.device?.enabled && this.device?.suspended) {
        count++
      }
      if (this.device?.service?.suspended || this.device?.service?.discontinued) {
        count++
      }
      return count
    },
    visibleAttributes() {
      return getVisibleAttributes(this.device.attributes, this.authStore.apiUser?.isIotAdmin)
    },
    visibleTags() {
      return getVisibleTags(this.device.tags, this.authStore.apiUser?.isIotAdmin)
    }
  },
  mounted() {
    this.loadDevice()
    this.checkSuspendedMessages()

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  beforeRouteEnter(to, from, next) {
    const { projectId } = to.params
    next((vm) => {
      vm.refreshPage(projectId)
    })
  },
  methods: {
    ...mapMutations({
      setNotification: "modals/setGlobalNotification",
      clearNotification: "modals/clearGlobalNotification"
    }),
    router() {
      return router
    },
    refreshPage(projectId) {
      if (this.projectStore.selectedProject && projectId !== this.projectStore.selectedProject.projectId) {
        window.location.reload()
      }
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    async loadDevice() {
      const id = this.$route.params.id
      const response = await axios.get(`${process.env.VUE_APP_API}/lora/devices/${id}`, {})
      this.device = response.data.data
      this.newAttributes = Object.assign({}, this.device.attributes)
      this.newTags = this.device.tags

      this.filterAttributes()
      this.loadLastMessage()
      this.loadService()
      this.loadGroupEndpoints()

      this.hwDevice = null
      if (this.device.hwDeviceId) {
        const { data } = await client.path("/hwdevices/{hwDeviceId}").method("get").create()({
          hwDeviceId: this.device.hwDeviceId
        })
        this.hwDevice = data.data
      }

      this.transformationFunction = null
      if (this.device.transformationId) {
        const { data } = await client.path("/transformations/{transformationId}").method("get").create()({
          transformationId: this.device.transformationId
        })
        this.transformationFunction = data.data
      }
      //
      // /** redirect to all lora devices if current project differs from new selected */
      // if (this.$route.params.projectId != this.device.projectId) {
      //   this.$router.push({ name: "lora" });
      // }
    },
    loadLastMessage() {
      if (this.device.lastMessageIn != null) {
        axios
          .get(
            process.env.VUE_APP_API +
              "/lora/devices/" +
              this.device.deviceId +
              "/up/messages?from=" +
              this.device.lastMessageIn +
              "&to=" +
              this.device.lastMessageIn +
              "&limit=1"
          )
          .then((result) => {
            const length = result.data.data.length
            let message = result.data.data[length - 1]
            message.type = "up"
            let gws = message.message.gws
            if (gws != null) {
              let sortedBySnr = _.orderBy(gws, "snr", "desc")
              let largestSnr = sortedBySnr[0].snr
              message.snr = largestSnr
              let sortedByRssi = _.orderBy(gws, "rssi", "desc")
              let largestRssi = sortedByRssi[0].rssi
              message.rssi = largestRssi
            }

            this.lastMessageIn = message
          })
          .catch(() => {})
      }
      if (this.device.lastMessageOut != null) {
        axios
          .get(
            process.env.VUE_APP_API +
              "/lora/devices/" +
              this.device.deviceId +
              "/down/messages?from=" +
              this.device.lastMessageOut +
              "&to=" +
              this.device.lastMessageOut
          )
          .then((result) => {
            const length = result.data.data.length
            let message = result.data.data[length - 1]
            message.type = "down"

            this.lastMessageOut = message
          })
          .catch(() => {})
      }
    },
    toggleDropdown() {
      this.openedDropdown ? (this.openedDropdown = false) : (this.openedDropdown = true)
    },
    loadService() {
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.device.custServiceId)
        .then((result) => {
          this.service = result.data.data
        })
        .catch(() => {})
    },
    async loadGroupEndpoints() {
      this.groups = []
      this.groupsEndpoints = []

      for (const deviceGroup of this.device.deviceGroups) {
        const groupResponse = await axios.get(`${process.env.VUE_APP_API}/device-groups/${deviceGroup.deviceGroupId}`)
        const group = groupResponse.data.data
        this.groups.push(group)

        const endpointsResponse = await axios.get(
          `${process.env.VUE_APP_API}/device-groups/${deviceGroup.deviceGroupId}/endpoints`
        )
        this.groupsEndpoints.push({
          group,
          endpoints: endpointsResponse.data.data
        })
      }
    },
    loadLogs() {
      axios
        .get(process.env.VUE_APP_API + "/audits/devices/" + this.id + "?sort=" + this.sort, {})
        .then((result) => {
          this.allLogs = result.data.data
        })
        .catch(() => {})
    },
    sortBy(sortingParam) {
      let newSortingParam = ""
      this.selectedRows = []
      this.isSelectedAllOnPage = false
      if (this.sort.indexOf(sortingParam) > -1) {
        if (this.sort.substring(2, 3) == "D") {
          newSortingParam = "%2B" + sortingParam
        } else {
          newSortingParam = "%2D" + sortingParam
        }
      } else {
        newSortingParam = "%2D" + sortingParam
      }
      this.sort = newSortingParam
    },
    filteredLogs(logs) {
      this.allLogs = logs
    },
    filteredMessages(messages) {
      this.allMessages = messages
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    showMessage(message) {
      this.selectedMessage = message
      this.openedMessageDetail.push("showMessage")
    },
    toggleDeleteDevice(items) {
      if (this.openedDeleteDevice == true) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    async deleteDevice() {
      this.errorsToTranslate = []
      let id = this.device.deviceId
      let notifications = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      try {
        await this.loraStore.deleteDevice(this.device)
        this.$store.commit("modals/setWaitingLoader", "")
        notifications.push({
          text: "notificationDeviceDelete",
          error: false,
          params: {
            deviceId: id,
            custDeviceName: this.device.custDeviceName
          }
        })
        this.$router.push({
          name: "lora",
          params: {
            customerId: this.selectedCustomerId,
            projectId: this.selectedProjectId,
            notifications: notifications
          }
        })
      } catch (e) {
        const er = [{ errors: [] }]
        let message = e.data.errors[0]
        er[0].errors.push({
          message: message,
          attribute: {
            deviceId: this.device.deviceId,
            custDeviceName: this.device.custDeviceName
          }
        })
        this.errorsToTranslate = er
        this.openedError = true
        this.$store.commit("modals/setWaitingLoader", "")
      }
    },
    toggleSendMessageModal(box) {
      if (box == undefined || this.openedSendMessage.indexOf(box) > -1) {
        box == undefined
          ? (this.openedSendMessage = [])
          : this.openedSendMessage.splice(this.openedSendMessage.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedSendMessage.push(box)
      }
    },
    setReloadDM(value) {
      this.reloadDM = false
      this.reloadDM = value
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)
      } else {
        this.openedEditDevice.push(box)
      }
    },
    toggleMoveDeviceModal(box) {
      if (this.openedMoveDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMoveDevice = [])
          : this.openedMoveDevice.splice(this.openedMoveDevice.indexOf(box), 1)
      } else {
        this.openedMoveDevice.push(box)
      }
    },
    handleTransformUpdated() {
      this.transformKey = Math.random().toString()
    },
    async editTags() {
      return axios
        .put(process.env.VUE_APP_API + "/lora/devices/" + this.device.deviceId + "/tags", this.newTags, {})
        .then(() => {
          this.device.tags = this.newTags
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    // sync updated attributes to IoTBE
    async editAttributes() {
      let attributes = this.newAttributes

      let promises = []

      promises.push(
        axios
          .put(process.env.VUE_APP_API + "/lora/devices/" + this.device.deviceId + "/attributes", attributes, {})
          .then(() => {
            this.newAttributes = this.device.attributes = attributes
            return true
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data)
            return true
          })
      )
      Promise.all(promises).then(() => {
        this.filterAttributes()
        //this.device.attributes = this.newAttributes;
      })
    },
    // remove attributes with hidden_ prefix
    filterAttributes() {
      let fAttributes = Object.assign({}, this.device.attributes)

      Object.keys(fAttributes).forEach((key) => (key.match("hidden_") ? delete fAttributes[key] : key))
      this.device.filteredAttributes = fAttributes
    },
    async handleDeviceMoved() {
      await this.$router.push({
        name: "devices",
        params: {
          customerId: this.selectedCustomerId,
          projectId: this.selectedProjectId
        }
      })

      this.clearNotification()
      this.setNotification({
        text: "NOTIFICATION_DEVICE_MOVED",
        error: false,
        params: {
          deviceId: this.deviceId
        }
      })
    },
    async checkSuspendedMessages() {
      const to = new Date().toISOString()
      const from = new Date(new Date() - 31 * 24 * 60 * 60 * 1000).toISOString()
      const upMessages = await axios.get(
        `${process.env.VUE_APP_API}/lora/devices/${this.deviceId}/up/messages?from=${from}&to=${to}&limit=1&messageStatus[in]=suspended`,
        {}
      )
      this.suspendedMessagesCount = upMessages.data.metadata.count
    }
  }
}
</script>
